import aemo from "aemo/client";
const environment = process.env.REACT_APP_ENVIRONMENT ?? "live";
aemo.setEnvironment(environment);

export const Aemo = aemo;